const classNames = (...args) => args.filter(className => className).join(' ');

export default classNames;
